<template>
    <div class="ppv2-flex ppv2-h-full">
        <!-- Lateral rail -->
        <nav
            class="ppv2-shrink-0 ppv2-w-[172px] ppv2-bg-gray-50 ppv2-border-r ppv2-border-gray-200 ppv2-px-2 ppv2-py-3 ppv2-flex ppv2-flex-col ppv2-gap-1"
        >
            <button
                v-for="tab in navTabs"
                :key="tab.id"
                type="button"
                class="ppv2-flex ppv2-items-center ppv2-w-full ppv2-rounded-[9px] ppv2-border ppv2-border-solid ppv2-px-3 ppv2-py-2.5 ppv2-text-[13px] ppv2-text-left ppv2-transition-colors ppv2-cursor-pointer hover:!ppv2-bg-primary-500 hover:!ppv2-bg-opacity-10"
                :class="
                    activeTab === tab.id
                        ? '!ppv2-bg-primary-500 !ppv2-bg-opacity-10 !ppv2-border-primary-300 !ppv2-text-primary-700 poppinsSemiBold'
                        : 'ppv2-bg-transparent ppv2-border-transparent ppv2-text-black poppinsMedium'
                "
                @click="activeTab = tab.id"
            >
                {{ tab.label }}
            </button>
        </nav>

        <!-- Content -->
        <div class="ppv2-flex-1 ppv2-overflow-y-auto ppv2-bg-white dark:ppv2-bg-dark ppv2-p-6">
            <!-- ============ 01 Réservation ============ -->
            <section v-if="activeTab === 'reservation'" class="ppv2-space-y-5">
                <header class="ppv2-flex ppv2-items-center ppv2-gap-3">
                    <h2 class="ppv2-text-[15.5px] poppinsSemiBold ppv2-text-black ppv2-m-0-forced">
                        {{ $t('configuration.reservationCancellationRulesForm.sections.reservation.title') }}
                    </h2>
                </header>

                <!-- Auto-confirmation -->
                <div
                    class="ppv2-flex ppv2-items-start ppv2-justify-between ppv2-gap-5 ppv2-p-3.5 ppv2-rounded-[10px] ppv2-border ppv2-border-gray-200"
                >
                    <div>
                        <p class="ppv2-text-[13.5px] poppinsSemiBold ppv2-text-black !ppv2-mb-0">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.reservation.autoConfirmation.label') }}
                        </p>
                        <p class="ppv2-text-[12.5px] ppv2-text-gray-500 ppv2-mt-1 ppv2-mb-2">
                            {{
                                $t(
                                    'configuration.reservationCancellationRulesForm.sections.reservation.autoConfirmation.description'
                                )
                            }}
                        </p>
                    </div>
                    <BaseSwitch v-model="formData.reservation_request" required class="ppv2-shrink-0" />
                </div>

                <InfoBanner
                    v-if="!formData.reservation_request"
                    variant="warning"
                    :text="$t('configuration.reservationCancellationRulesForm.sections.reservation.autoConfirmation.messageBox')"
                />

                <div class="ppv2-h-px ppv2-bg-gray-200"></div>

                <!-- Minimum time before reservation -->
                <div class="">
                    <div class="ppv2-flex-1">
                        <p class="ppv2-text-[13px] poppinsSemiBold ppv2-text-black ppv2-mb-0">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.reservation.minTime.label') }}
                        </p>
                        <p class="ppv2-text-[12.5px] ppv2-text-gray-500 ppv2-mt-1 ppv2-mb-2">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.reservation.minTime.description') }}
                        </p>
                    </div>
                    <div
                        class="ppv2-shrink-0 ppv2-w-[220px] ppv2-flex ppv2-items-center ppv2-overflow-hidden ppv2-rounded-lg ppv2-border ppv2-border-gray-300 ppv2-focus-within:ppv2-border-primary-500"
                    >
                        <input
                            v-model.number="formData.must_reserved_before"
                            type="number"
                            min="0"
                            step="1"
                            class="number-input ppv2-w-full ppv2-min-w-0 ppv2-px-3 ppv2-py-2 ppv2-text-[13.5px] ppv2-text-black ppv2-bg-transparent focus:ppv2-outline-none"
                        />
                        <span
                            class="ppv2-shrink-0 ppv2-self-stretch ppv2-flex ppv2-items-center ppv2-px-3 ppv2-text-xs ppv2-text-gray-500 ppv2-bg-gray-50 ppv2-border-l ppv2-border-gray-200"
                        >
                            {{ $t('configuration.reservationCancellationRulesForm.sections.reservation.minTime.suffix') }}
                        </span>
                    </div>
                </div>

                <!-- Basket blocking duration -->
                <div class="">
                    <div class="ppv2-flex-1">
                        <p class="ppv2-text-[13px] poppinsSemiBold ppv2-text-black ppv2-mb-0">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.reservation.basketLock.label') }}
                        </p>
                        <p class="ppv2-text-[12.5px] ppv2-text-gray-500 ppv2-mt-1 ppv2-mb-2">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.reservation.basketLock.description') }}
                        </p>
                    </div>
                    <div
                        class="ppv2-shrink-0 ppv2-w-[220px] ppv2-flex ppv2-items-center ppv2-overflow-hidden ppv2-rounded-lg ppv2-border"
                        :class="
                            timeDeleteUnpaidOrderError
                                ? 'ppv2-border-red-400'
                                : 'ppv2-border-gray-300 ppv2-focus-within:ppv2-border-primary-500'
                        "
                    >
                        <input
                            v-model.number="formData.time_delete_unpaid_order"
                            type="number"
                            min="5"
                            step="1"
                            class="number-input ppv2-w-full ppv2-min-w-0 ppv2-px-3 ppv2-py-2 ppv2-text-[13.5px] ppv2-text-black ppv2-bg-transparent focus:ppv2-outline-none"
                        />
                        <span
                            class="ppv2-shrink-0 ppv2-self-stretch ppv2-flex ppv2-items-center ppv2-px-3 ppv2-text-xs ppv2-text-gray-500 ppv2-bg-gray-50 ppv2-border-l ppv2-border-gray-200"
                        >
                            {{ $t('configuration.reservationCancellationRulesForm.sections.reservation.basketLock.suffix') }}
                        </span>
                    </div>
                </div>
                <p v-if="timeDeleteUnpaidOrderError" class="ppv2-text-xs ppv2-text-red-500 ppv2--mt-3.5">
                    {{ timeDeleteUnpaidOrderError }}
                </p>

                <!-- Bank imprint release delay -->
                <div class="">
                    <div class="ppv2-flex-1">
                        <p class="ppv2-text-[13px] poppinsSemiBold ppv2-text-black ppv2-mb-0">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.reservation.bankImprint.label') }}
                        </p>
                        <p class="ppv2-text-[12.5px] ppv2-text-gray-500 ppv2-mt-1 ppv2-mb-2">
                            {{
                                $t('configuration.reservationCancellationRulesForm.sections.reservation.bankImprint.description')
                            }}
                        </p>
                    </div>
                    <div
                        class="ppv2-shrink-0 ppv2-w-[220px] ppv2-flex ppv2-items-center ppv2-overflow-hidden ppv2-rounded-lg ppv2-border ppv2-border-gray-300 ppv2-focus-within:ppv2-border-primary-500"
                    >
                        <input
                            v-model.number="formData.time_free_finger_print"
                            type="number"
                            min="0"
                            step="1"
                            class="number-input ppv2-w-full ppv2-min-w-0 ppv2-px-3 ppv2-py-2 ppv2-text-[13.5px] ppv2-text-black ppv2-bg-transparent focus:ppv2-outline-none"
                        />
                        <span
                            class="ppv2-shrink-0 ppv2-self-stretch ppv2-flex ppv2-items-center ppv2-px-3 ppv2-text-xs ppv2-text-gray-500 ppv2-bg-gray-50 ppv2-border-l ppv2-border-gray-200"
                        >
                            {{ $t('configuration.reservationCancellationRulesForm.sections.reservation.bankImprint.suffix') }}
                        </span>
                    </div>
                </div>

                <div class="ppv2-h-px ppv2-bg-gray-200"></div>

                <!-- Transparency -->
                <!--div class="ppv2-space-y-3">
                    <h3 class="ppv2-text-[13px] poppinsSemiBold ppv2-text-black ppv2-m-0-forced">
                        {{
                            $t(
                                'configuration.reservationCancellationRulesForm.sections.reservation.transparency.label'
                            )
                        }}
                    </h3>

                    <div
                        class="ppv2-flex ppv2-items-start ppv2-gap-2.5 ppv2-cursor-pointer ppv2-select-none"
                        @click="toggleTransparency('show_cancellation_policy_booking_page')"
                    >
                        <span
                            class="ppv2-shrink-0 ppv2-mt-0.5 ppv2-w-[18px] ppv2-h-[18px] ppv2-rounded-[5px] ppv2-border-[1.5px] ppv2-flex ppv2-items-center ppv2-justify-center ppv2-transition-colors"
                            :class="
                                formData.show_cancellation_policy_booking_page
                                    ? 'ppv2-bg-primary-500 ppv2-border-primary-500 ppv2-text-white'
                                    : 'ppv2-bg-white ppv2-border-gray-300'
                            "
                        >
                            <Check v-if="formData.show_cancellation_policy_booking_page" :size="12" :stroke-width="3" />
                        </span>
                        <span>
                            <span class="ppv2-block ppv2-text-[13px] poppinsMedium ppv2-text-black">
                                {{
                                    $t(
                                        'configuration.reservationCancellationRulesForm.sections.reservation.transparency.options.joinConditions.label'
                                    )
                                }}
                            </span>
                        </span>
                    </div>

                    <div
                        class="ppv2-flex ppv2-items-start ppv2-gap-2.5 ppv2-cursor-pointer ppv2-select-none"
                        @click="toggleTransparency('attach_conditions_confirmation_emails')"
                    >
                        <span
                            class="ppv2-shrink-0 ppv2-mt-0.5 ppv2-w-[18px] ppv2-h-[18px] ppv2-rounded-[5px] ppv2-border-[1.5px] ppv2-flex ppv2-items-center ppv2-justify-center ppv2-transition-colors"
                            :class="
                                formData.attach_conditions_confirmation_emails
                                    ? 'ppv2-bg-primary-500 ppv2-border-primary-500 ppv2-text-white'
                                    : 'ppv2-bg-white ppv2-border-gray-300'
                            "
                        >
                            <Check v-if="formData.attach_conditions_confirmation_emails" :size="12" :stroke-width="3" />
                        </span>
                        <span>
                            <span class="ppv2-block ppv2-text-[13px] poppinsMedium ppv2-text-black">
                                {{
                                    $t(
                                        'configuration.reservationCancellationRulesForm.sections.reservation.transparency.options.displayImprintInformation.label'
                                    )
                                }}
                            </span>
                        </span>
                    </div>

                    <div
                        class="ppv2-flex ppv2-items-start ppv2-gap-2.5 ppv2-cursor-pointer ppv2-select-none"
                        @click="toggleTransparency('display_bank_imprint_or_deposit_information')"
                    >
                        <span
                            class="ppv2-shrink-0 ppv2-mt-0.5 ppv2-w-[18px] ppv2-h-[18px] ppv2-rounded-[5px] ppv2-border-[1.5px] ppv2-flex ppv2-items-center ppv2-justify-center ppv2-transition-colors"
                            :class="
                                formData.display_bank_imprint_or_deposit_information
                                    ? 'ppv2-bg-primary-500 ppv2-border-primary-500 ppv2-text-white'
                                    : 'ppv2-bg-white ppv2-border-gray-300'
                            "
                        >
                            <Check v-if="formData.display_bank_imprint_or_deposit_information" :size="12" :stroke-width="3" />
                        </span>
                        <span>
                            <span class="ppv2-block ppv2-text-[13px] poppinsMedium ppv2-text-black">
                                {{
                                    $t(
                                        'configuration.reservationCancellationRulesForm.sections.reservation.transparency.options.displayCancellationPolicy.label'
                                    )
                                }}
                            </span>
                        </span>
                    </div>

                    <div
                        class="ppv2-flex ppv2-items-start ppv2-gap-2.5 ppv2-cursor-pointer ppv2-select-none"
                        @click="formData.show_available_places = !formData.show_available_places"
                    >
                        <span
                            class="ppv2-shrink-0 ppv2-mt-0.5 ppv2-w-[18px] ppv2-h-[18px] ppv2-rounded-[5px] ppv2-border-[1.5px] ppv2-flex ppv2-items-center ppv2-justify-center ppv2-transition-colors"
                            :class="
                                formData.show_available_places
                                    ? 'ppv2-bg-primary-500 ppv2-border-primary-500 ppv2-text-white'
                                    : 'ppv2-bg-white ppv2-border-gray-300'
                            "
                        >
                            <Check v-if="formData.show_available_places" :size="12" :stroke-width="3" />
                        </span>
                        <span>
                            <span class="ppv2-block ppv2-text-[13px] poppinsMedium ppv2-text-black">
                                {{
                                    $t(
                                        'configuration.reservationCancellationRulesForm.sections.reservation.transparency.placesDisponibles'
                                    )
                                }}
                            </span>
                        </span>
                    </div>
                </div-->
            </section>

            <!-- ============ 02 Annulation ============ -->
            <section v-if="activeTab === 'cancellation'" class="ppv2-space-y-5">
                <header class="ppv2-flex ppv2-items-center ppv2-gap-3">
                    <h2 class="ppv2-text-[15.5px] poppinsSemiBold ppv2-text-black ppv2-m-0-forced">
                        {{ $t('configuration.reservationCancellationRulesForm.sections.cancellation.title') }}
                    </h2>
                </header>

                <!-- Cancellation by customer -->
                <div
                    class="ppv2-flex ppv2-items-start ppv2-justify-between ppv2-gap-5 ppv2-p-3.5 ppv2-rounded-[10px] ppv2-border ppv2-border-gray-200"
                >
                    <div>
                        <p class="ppv2-text-[13.5px] poppinsSemiBold ppv2-text-black !ppv2-mb-0">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.cancellation.byCustomer.label') }}
                        </p>
                        <p class="ppv2-text-[12.5px] ppv2-text-gray-500 ppv2-mt-1 ppv2-mb-2">
                            {{
                                $t('configuration.reservationCancellationRulesForm.sections.cancellation.byCustomer.description')
                            }}
                        </p>
                    </div>
                    <BaseSwitch v-model="formData.front_office" class="ppv2-shrink-0" />
                </div>

                <!-- Refund tiers -->
                <div class="">
                    <h3 class="ppv2-text-[13px] poppinsSemiBold ppv2-text-black ppv2-mb-2">
                        {{ $t('configuration.reservationCancellationRulesForm.sections.cancellation.tiers.title') }}
                    </h3>
                    <p class="ppv2-text-[12.5px] ppv2-text-gray-500 ppv2-mb-2">
                        {{ $t('configuration.reservationCancellationRulesForm.sections.cancellation.tiers.description') }}
                    </p>

                    <!-- Table header -->
                    <div
                        class="ppv2-grid ppv2-items-center ppv2-gap-2.5 ppv2-px-3 ppv2-py-2 ppv2-rounded-t-[10px] ppv2-border ppv2-border-b-0 ppv2-border-gray-200 ppv2-bg-gray-50"
                        style="grid-template-columns: 1fr 1fr 30px"
                    >
                        <span class="ppv2-text-[11.5px] poppinsSemiBold ppv2-text-gray-600 ppv2-uppercase ppv2-tracking-wide">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.cancellation.tiers.columnDelay') }}
                        </span>
                        <span class="ppv2-text-[11.5px] poppinsSemiBold ppv2-text-gray-600 ppv2-uppercase ppv2-tracking-wide">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.cancellation.tiers.columnPercent') }}
                        </span>
                        <span></span>
                    </div>

                    <!-- Tiers table -->
                    <div v-if="cancelRows.length" class="ppv2-border ppv2-border-b-0 ppv2-border-gray-200 ppv2-overflow-hidden">
                        <div
                            v-for="(row, index) in cancelRows"
                            :key="index"
                            class="ppv2-grid ppv2-items-center ppv2-gap-2.5 ppv2-px-3 ppv2-py-2"
                            style="grid-template-columns: 1fr 1fr 30px"
                        >
                            <div
                                class="ppv2-flex ppv2-items-stretch ppv2-overflow-hidden ppv2-rounded-lg ppv2-border ppv2-border-gray-300"
                            >
                                <span
                                    class="ppv2-shrink-0 ppv2-flex ppv2-items-center ppv2-px-2.5 ppv2-text-xs poppinsSemiBold ppv2-text-gray-500 ppv2-bg-gray-50 ppv2-border-r ppv2-border-gray-200"
                                >
                                    {{
                                        $t(
                                            'configuration.reservationCancellationRulesForm.sections.cancellation.tiers.prefixDays'
                                        )
                                    }}
                                </span>
                                <input
                                    v-model.number="row.time"
                                    type="number"
                                    min="0"
                                    step="1"
                                    class="number-input ppv2-w-full ppv2-min-w-0 ppv2-px-2.5 ppv2-py-2 ppv2-text-[13.5px] poppinsSemiBold ppv2-text-black ppv2-bg-transparent focus:ppv2-outline-none"
                                />
                            </div>
                            <div
                                class="ppv2-flex ppv2-items-stretch ppv2-overflow-hidden ppv2-rounded-lg ppv2-border ppv2-border-gray-300"
                            >
                                <input
                                    v-model.number="row.rate"
                                    type="number"
                                    min="0"
                                    max="100"
                                    step="1"
                                    class="number-input ppv2-w-full ppv2-min-w-0 ppv2-px-2.5 ppv2-py-2 ppv2-text-[13.5px] poppinsSemiBold ppv2-text-black ppv2-bg-transparent focus:ppv2-outline-none"
                                />
                                <span
                                    class="ppv2-shrink-0 ppv2-flex ppv2-items-center ppv2-px-2.5 ppv2-text-xs poppinsSemiBold ppv2-text-gray-500 ppv2-bg-gray-50 ppv2-border-l ppv2-border-gray-200"
                                >
                                    {{
                                        $t(
                                            'configuration.reservationCancellationRulesForm.sections.cancellation.tiers.suffixPercent'
                                        )
                                    }}
                                </span>
                            </div>
                            <button
                                type="button"
                                class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-w-[30px] ppv2-h-[30px] ppv2-rounded-lg ppv2-border ppv2-border-solid ppv2-border-gray-200 ppv2-text-gray-500 hover:ppv2-text-[#c0392b] hover:ppv2-border-[#c0392b] hover:ppv2-bg-[#c0392b] hover:ppv2-bg-opacity-10 ppv2-transition-colors ppv2-cursor-pointer"
                                :title="
                                    $t('configuration.reservationCancellationRulesForm.sections.cancellation.tiers.deleteTitle')
                                "
                                @click="removeTier(index)"
                            >
                                ✕
                            </button>
                        </div>
                    </div>

                    <!-- Add tier -->
                    <button
                        type="button"
                        class="ppv2-w-full pv2-flex ppv2-items-center ppv2-justify-center ppv2-gap-1.5 ppv2-px-3 ppv2-py-2 ppv2-rounded-b-[10px] ppv2-border ppv2-border-solid ppv2-border-gray-300 ppv2-text-gray-500 ppv2-text-[12.5px] poppinsMedium hover:ppv2-bg-primary-500 hover:ppv2-bg-opacity-10 hover:ppv2-text-primary-500 ppv2-transition-colors ppv2-cursor-pointer"
                        @click="addTier"
                    >
                        + {{ $t('configuration.reservationCancellationRulesForm.sections.cancellation.tiers.addTier') }}
                    </button>
                </div>
            </section>

            <!-- ============ 03 Modification ============ -->
            <section v-if="activeTab === 'modification'" class="ppv2-space-y-5">
                <header class="ppv2-flex ppv2-items-center ppv2-gap-3">
                    <h2 class="ppv2-text-[15.5px] poppinsSemiBold ppv2-text-black ppv2-m-0-forced">
                        {{ $t('configuration.reservationCancellationRulesForm.sections.modification.title') }}
                    </h2>
                </header>

                <!-- Modification enabled -->
                <div
                    class="ppv2-flex ppv2-items-start ppv2-justify-between ppv2-gap-5 ppv2-p-3.5 ppv2-rounded-[10px] ppv2-border ppv2-border-gray-200"
                >
                    <div>
                        <p class="ppv2-text-[13.5px] poppinsSemiBold ppv2-text-black !ppv2-mb-0">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.modification.enabled.label') }}
                        </p>
                        <p class="ppv2-text-[12.5px] ppv2-text-gray-500 ppv2-mt-1 ppv2-mb-2">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.modification.enabled.description') }}
                        </p>
                    </div>
                    <BaseSwitch v-model="modificationPolicy.enabled" class="ppv2-shrink-0" />
                </div>

                <template v-if="modificationPolicy.enabled">
                    <!-- Modification deadline -->
                    <div class="">
                        <div class="ppv2-flex-1">
                            <p class="ppv2-text-[13px] poppinsSemiBold ppv2-text-black ppv2-mb-0">
                                {{ $t('configuration.reservationCancellationRulesForm.sections.modification.deadline.label') }}
                            </p>
                            <p class="ppv2-text-[12.5px] ppv2-text-gray-500 ppv2-mt-1 ppv2-mb-2">
                                {{
                                    $t(
                                        'configuration.reservationCancellationRulesForm.sections.modification.deadline.description'
                                    )
                                }}
                            </p>
                        </div>
                        <div
                            class="ppv2-shrink-0 ppv2-w-[220px] ppv2-flex ppv2-items-center ppv2-overflow-hidden ppv2-rounded-lg ppv2-border ppv2-border-gray-300 ppv2-focus-within:ppv2-border-primary-500"
                        >
                            <input
                                v-model.number="modificationPolicy.delay_days"
                                type="number"
                                min="0"
                                step="1"
                                class="number-input ppv2-w-full ppv2-min-w-0 ppv2-px-3 ppv2-py-2 ppv2-text-[13.5px] ppv2-text-black ppv2-bg-transparent focus:ppv2-outline-none"
                            />
                            <span
                                class="ppv2-shrink-0 ppv2-self-stretch ppv2-flex ppv2-items-center ppv2-px-3 ppv2-text-xs ppv2-text-gray-500 ppv2-bg-gray-50 ppv2-border-l ppv2-border-gray-200"
                            >
                                {{ $t('configuration.reservationCancellationRulesForm.sections.modification.deadline.suffix') }}
                            </span>
                        </div>
                    </div>

                    <!-- Complement block (higher amount) -->
                    <div class="">
                        <p class="ppv2-text-[13px] poppinsSemiBold ppv2-text-black ppv2-m-0-forced">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.modification.complement.title') }}
                        </p>
                        <p class="ppv2-text-[12.5px] ppv2-text-gray-500 ppv2-mt-1 ppv2-mb-2">
                            {{
                                $t('configuration.reservationCancellationRulesForm.sections.modification.complement.description')
                            }}
                        </p>
                        <div class="ppv2-flex ppv2-flex-col ppv2-gap-2 ppv2-max-w-[420px]">
                            <div
                                v-for="mode in complementOptions"
                                :key="mode.value"
                                class="ppv2-flex ppv2-items-center ppv2-gap-2.5 ppv2-cursor-pointer ppv2-select-none ppv2-rounded-lg ppv2-border ppv2-px-3 ppv2-py-2 ppv2-transition-colors"
                                :class="
                                    complementSelection.includes(mode.value)
                                        ? 'ppv2-border-primary-300 ppv2-bg-primary-500 ppv2-bg-opacity-10'
                                        : 'ppv2-border-gray-200 ppv2-bg-white'
                                "
                                @click="toggleComplement(mode.value)"
                            >
                                <span
                                    class="ppv2-shrink-0 ppv2-w-[18px] ppv2-h-[18px] ppv2-rounded-[5px] ppv2-border-[1.5px] ppv2-flex ppv2-items-center ppv2-justify-center ppv2-transition-colors"
                                    :class="
                                        complementSelection.includes(mode.value)
                                            ? 'ppv2-bg-primary-500 ppv2-border-primary-500 ppv2-text-white'
                                            : 'ppv2-bg-white ppv2-border-gray-300'
                                    "
                                >
                                    <Check v-if="complementSelection.includes(mode.value)" :size="12" :stroke-width="3" />
                                </span>
                                <span class="ppv2-flex-1 ppv2-text-[13px] poppinsMedium ppv2-text-black">
                                    {{ mode.label }}
                                </span>
                            </div>
                        </div>
                        <p v-if="complementError" class="ppv2-text-xs ppv2-text-red-500 ppv2-mt-1">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.modification.complement.error') }}
                        </p>
                    </div>

                    <!-- Refund block (lower amount) -->
                    <div class="">
                        <p class="ppv2-text-[13px] poppinsSemiBold ppv2-text-black ppv2-m-0-forced">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.modification.refund.title') }}
                        </p>
                        <p class="ppv2-text-[12.5px] ppv2-text-gray-500 ppv2-mt-1 ppv2-mb-2">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.modification.refund.description') }}
                        </p>

                        <!-- Keep original payment method -->
                        <div
                            class="ppv2-flex ppv2-items-start ppv2-justify-between ppv2-gap-4 ppv2-px-3.5 ppv2-py-3 ppv2-rounded-[10px] ppv2-border ppv2-border-gray-200 ppv2-mb-2"
                        >
                            <div>
                                <p class="ppv2-text-[13px] poppinsSemiBold ppv2-text-black ppv2-mb-0">
                                    {{
                                        $t(
                                            'configuration.reservationCancellationRulesForm.sections.modification.refund.keepOriginal.label'
                                        )
                                    }}
                                </p>
                                <p class="ppv2-text-[12px] ppv2-text-gray-500 ppv2-mt-1">
                                    {{
                                        $t(
                                            'configuration.reservationCancellationRulesForm.sections.modification.refund.keepOriginal.description'
                                        )
                                    }}
                                </p>
                            </div>
                            <BaseSwitch v-model="keepOriginal" class="ppv2-shrink-0" />
                        </div>

                        <!-- Fallback methods -->
                        <p class="ppv2-text-[12.5px] poppinsSemiBold ppv2-text-black ppv2-mb-2">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.modification.refund.fallback') }}
                        </p>
                        <div class="ppv2-flex ppv2-flex-col ppv2-gap-2 ppv2-max-w-[420px]">
                            <div
                                v-for="mode in fallbackOptions"
                                :key="mode.value"
                                class="ppv2-flex ppv2-items-center ppv2-gap-2.5 ppv2-cursor-pointer ppv2-select-none ppv2-rounded-lg ppv2-border ppv2-px-3 ppv2-py-2 ppv2-transition-colors"
                                :class="
                                    refundFallback.includes(mode.value)
                                        ? 'ppv2-border-primary-300 ppv2-bg-primary-500 ppv2-bg-opacity-10'
                                        : 'ppv2-border-gray-200 ppv2-bg-white dark:ppv2-bg-dark'
                                "
                                @click="toggleRefundFallback(mode.value)"
                            >
                                <span
                                    class="ppv2-shrink-0 ppv2-w-[18px] ppv2-h-[18px] ppv2-rounded-[5px] ppv2-border-[1.5px] ppv2-flex ppv2-items-center ppv2-justify-center ppv2-transition-colors"
                                    :class="
                                        refundFallback.includes(mode.value)
                                            ? 'ppv2-bg-primary-500 ppv2-border-primary-500 ppv2-text-white'
                                            : 'ppv2-bg-white dark:ppv2-bg-dark ppv2-border-gray-300'
                                    "
                                >
                                    <Check v-if="refundFallback.includes(mode.value)" :size="12" :stroke-width="3" />
                                </span>
                                <span class="ppv2-flex-1 ppv2-text-[13px] poppinsMedium ppv2-text-black">
                                    {{ mode.label }}
                                </span>
                            </div>
                        </div>
                        <p v-if="refundError" class="ppv2-text-xs ppv2-text-red-500 ppv2-mt-1">
                            {{ $t('configuration.reservationCancellationRulesForm.sections.modification.refund.error') }}
                        </p>
                    </div>
                </template>
            </section>
        </div>
    </div>
</template>

<script>
import InfoBanner from '../../../Shared/InfoBanner.vue'
import BaseSwitch from '../../../Shared/BaseSwitch.vue'
import { Check } from 'lucide-vue'

const MIN_TIME_DELETE_UNPAID_ORDER = 5

const fieldsSettings = [
    'show_cancellation_policy_booking_page',
    'attach_conditions_confirmation_emails',
    'display_bank_imprint_or_deposit_information',
]

const fieldsEstablishment = [
    'reservation_request',
    'must_reserved_before',
    'time_delete_unpaid_order',
    'time_free_finger_print',
    'front_office',
    'show_available_places',
]

const ALLOWED_REFUND_MODES = ['voucher', 'wallet', 'stripe']
const ALLOWED_COMPLEMENT_MODES = ['stripe', 'wallet', 'voucher']

export default {
    name: 'ReservationCancellationRulesForm',
    components: {
        InfoBanner,
        BaseSwitch,
        Check,
    },
    data() {
        return {
            activeTab: 'reservation',
            isInitializing: true,
            formData: {
                reservation_request: false,
                must_reserved_before: null,
                time_delete_unpaid_order: null,
                time_free_finger_print: null,
                front_office: false,
                show_cancellation_policy_booking_page: false,
                attach_conditions_confirmation_emails: false,
                display_bank_imprint_or_deposit_information: false,
                show_available_places: false,
            },
            // Reservation modification policy (dedicated table — NOT an establishment
            // column nor an app setting, so kept OUT of formData to avoid the appSetting watcher).
            modificationPolicy: {
                enabled: true,
                delay_days: 3,
                // Refund block applied when the reservation was NOT paid by Stripe.
                refund_enabled: false,
                refund_modes: ['voucher'],
                refund_customer_can_choose: false,
                refund_default_mode: 'voucher',
                // Parallel refund block applied when the reservation WAS paid by Stripe (card).
                // Mirrored from the base block (single-source UI).
                stripe_refund_enabled: false,
                stripe_refund_modes: ['voucher'],
                stripe_refund_customer_can_choose: false,
                stripe_refund_default_mode: 'voucher',
                // Complement block (delta > 0: which methods can pay the difference).
                complement_enabled: true,
                complement_modes: ['stripe', 'wallet', 'voucher'],
                complement_customer_can_choose: true,
                complement_default_mode: 'stripe',
            },
            complementSelection: ['stripe'],
            refundFallback: ['wallet'],
            keepOriginal: true,
            complementError: false,
            refundError: false,
            cancelRows: [],
        }
    },
    computed: {
        navTabs() {
            const prefix = 'configuration.reservationCancellationRulesForm.nav.'
            return [
                { id: 'reservation', label: this.$t(prefix + 'reservation') },
                { id: 'cancellation', label: this.$t(prefix + 'cancellation') },
                { id: 'modification', label: this.$t(prefix + 'modification') },
            ]
        },
        complementOptions() {
            const prefix = 'configuration.reservationCancellationRulesForm.sections.modification.complement.options.'
            return ALLOWED_COMPLEMENT_MODES.map((value) => ({ value, label: this.$t(prefix + value) }))
        },
        fallbackOptions() {
            const prefix = 'configuration.reservationCancellationRulesForm.sections.modification.refund.options.'
            return ['wallet', 'voucher'].map((value) => ({ value, label: this.$t(prefix + value) }))
        },
        establishmentCancelRate() {
            return this.$store.getters['establishment/establishmentCancelRate']
        },
        appSetting() {
            return this.$store.getters['establishment/appSetting']
        },
        establishment() {
            return this.$store.getters['establishment/establishment']
        },
        timeDeleteUnpaidOrderError() {
            if (
                this.formData.time_delete_unpaid_order !== null &&
                this.formData.time_delete_unpaid_order !== undefined &&
                this.formData.time_delete_unpaid_order < MIN_TIME_DELETE_UNPAID_ORDER
            ) {
                return this.$t('configuration.reservationCancellationRulesForm.sections.reservation.basketLock.error')
            }
            return null
        },
    },
    watch: {
        establishment: {
            handler() {
                this.initializeForm()
            },
            immediate: true,
            deep: true,
        },
        formData: {
            deep: true,
            handler(newVal) {
                if (this.isInitializing) return
                this.$emit('update', newVal)
                const updatedAppSettings = Object.entries(newVal)
                    .filter(([key]) => !fieldsEstablishment.includes(key))
                    .map(([key, value]) => ({ key, value }))
                this.$store.commit('establishment/ADD_APP_SETTING', updatedAppSettings)
            },
        },
        modificationPolicy: {
            deep: true,
            handler(newVal) {
                this.$store.commit('establishment/SET_ESTABLISHMENT_MODIFICATION_POLICY', { ...newVal })
            },
        },
        cancelRows: {
            deep: true,
            handler() {
                if (this.isInitializing) return
                this.commitCancelRates()
            },
        },
        keepOriginal() {
            if (this.isInitializing) return
            this.syncRefund()
        },
    },
    methods: {
        initializeForm() {
            fieldsEstablishment.forEach((field) => {
                if (this.establishment && this.establishment.hasOwnProperty(field)) {
                    this.formData[field] = this.establishment[field]
                }
            })
            this.initModificationPolicy()
            this.initCancelRows()
        },
        initModificationPolicy() {
            const rows =
                (this.establishment && (this.establishment.modification_policies || this.establishment.modificationPolicies)) ||
                []
            const map = {}
            if (Array.isArray(rows)) {
                rows.forEach((r) => {
                    map[r.key] = r.value
                })
            }
            const toBool = (v, def) => (v === undefined || v === null ? def : v === '1' || v === 1 || v === true || v === 'true')
            const parseModes = (raw, allowed, fallback) => {
                let parsed = []
                if (Array.isArray(raw)) {
                    parsed = raw
                } else if (typeof raw === 'string' && raw !== '') {
                    try {
                        const decoded = JSON.parse(raw)
                        if (Array.isArray(decoded)) parsed = decoded
                    } catch (e) {
                        parsed = []
                    }
                }
                parsed = parsed.filter((m) => allowed.includes(m))
                if (!parsed.length) parsed = [...fallback]
                return parsed
            }

            const refundModes = parseModes(map.refund_modes, ALLOWED_REFUND_MODES, ['voucher'])
            const complementModes = parseModes(map.complement_modes, ALLOWED_COMPLEMENT_MODES, ['stripe'])

            this.modificationPolicy = {
                enabled: toBool(map.enabled, true),
                delay_days: map.delay_days != null ? Number(map.delay_days) : 3,
                refund_enabled: toBool(map.refund_enabled, false),
                refund_modes: refundModes,
                refund_customer_can_choose: refundModes.length >= 2,
                refund_default_mode: refundModes.includes(map.refund_default_mode) ? map.refund_default_mode : refundModes[0],
                stripe_refund_enabled: toBool(map.refund_enabled, false),
                stripe_refund_modes: [...refundModes],
                stripe_refund_customer_can_choose: refundModes.length >= 2,
                stripe_refund_default_mode: refundModes.includes(map.refund_default_mode)
                    ? map.refund_default_mode
                    : refundModes[0],
                complement_enabled: toBool(map.complement_enabled, true),
                complement_modes: complementModes,
                complement_customer_can_choose: toBool(map.complement_customer_can_choose, true),
                complement_default_mode: complementModes.includes(map.complement_default_mode)
                    ? map.complement_default_mode
                    : complementModes[0],
            }

            this.complementSelection = [...complementModes]
            this.refundFallback = refundModes.filter((m) => m !== 'stripe')
            if (!this.refundFallback.length) this.refundFallback = ['voucher']
            this.keepOriginal = refundModes.includes('stripe')

            // Seed the store so saving without touching the section preserves the policy.
            this.$store.commit('establishment/SET_ESTABLISHMENT_MODIFICATION_POLICY', { ...this.modificationPolicy })
        },
        initCancelRows() {
            if (Array.isArray(this.establishmentCancelRate)) {
                this.cancelRows = this.establishmentCancelRate.map((r) => ({
                    time: Number(r.time) || 0,
                    rate: Number(r.rate) || 0,
                }))
            } else {
                this.cancelRows = []
            }
        },
        autoFillFromWebsiteSetting() {
            if (!this.appSetting || !Array.isArray(this.appSetting)) return
            fieldsSettings.forEach((key) => {
                const item = this.appSetting.find((s) => s.key === key)
                if (!item) return
                const currentValue = this.formData[key]
                if (typeof currentValue === 'boolean') {
                    this.formData[key] = item.value == 1 || item.value === true || item.value === '1'
                } else if (typeof currentValue === 'number') {
                    this.formData[key] = Number(item.value)
                } else {
                    this.formData[key] = item.value
                }
            })
        },
        toggleTransparency(field) {
            this.formData[field] = !this.formData[field]
        },
        toggleComplement(mode) {
            const list = [...this.complementSelection]
            const idx = list.indexOf(mode)
            if (idx >= 0) {
                list.splice(idx, 1)
            } else {
                list.push(mode)
            }
            this.complementSelection = list
            this.complementError = false
            this.syncComplement()
        },
        syncComplement() {
            const modes = [...this.complementSelection]
            this.modificationPolicy.complement_modes = modes
            if (modes.length) {
                this.modificationPolicy.complement_default_mode = this.modificationPolicy.complement_modes.includes(
                    this.modificationPolicy.complement_default_mode
                )
                    ? this.modificationPolicy.complement_default_mode
                    : this.modificationPolicy.complement_modes[0]
            }
        },
        toggleRefundFallback(mode) {
            const list = [...this.refundFallback]
            const idx = list.indexOf(mode)
            if (idx >= 0) {
                list.splice(idx, 1)
            } else {
                list.push(mode)
            }
            this.refundFallback = list
            this.refundError = false
            this.syncRefund()
        },
        syncRefund() {
            const fallback = [...new Set(this.refundFallback)]
            const modes = this.keepOriginal ? ['stripe', ...fallback] : fallback
            const customerCanChoose = fallback.length >= 2
            this.modificationPolicy.refund_modes = [...new Set(modes)]
            this.modificationPolicy.refund_customer_can_choose = customerCanChoose
            this.modificationPolicy.refund_default_mode = this.keepOriginal ? 'stripe' : this.modificationPolicy.refund_modes[0]
            // Mirror the single-source block to the Stripe-paid parallel block.
            this.modificationPolicy.stripe_refund_enabled = this.modificationPolicy.refund_enabled
            this.modificationPolicy.stripe_refund_modes = [...this.modificationPolicy.refund_modes]
            this.modificationPolicy.stripe_refund_customer_can_choose = customerCanChoose
            this.modificationPolicy.stripe_refund_default_mode = this.modificationPolicy.refund_default_mode
        },
        addTier() {
            const lastTime = this.cancelRows.length ? Math.max(...this.cancelRows.map((r) => Number(r.time) || 0)) : -1
            this.cancelRows.push({ time: lastTime + 1, rate: 0 })
        },
        removeTier(index) {
            this.cancelRows.splice(index, 1)
        },
        commitCancelRates() {
            const updatedAppSettings = this.cancelRows.map((entry, index) => ({
                key: index + 1,
                time: Number(entry.time) || 0,
                rate: Number(entry.rate) || 0,
                type: 1,
                establishment_id: this.establishment.id,
            }))
            this.$store.commit('establishment/SET_ESTABLISHMENT_CANCEL_RATE', updatedAppSettings)
        },
        validateForm() {
            if (
                this.formData.time_delete_unpaid_order !== null &&
                this.formData.time_delete_unpaid_order !== undefined &&
                this.formData.time_delete_unpaid_order < MIN_TIME_DELETE_UNPAID_ORDER
            ) {
                return false
            }
            if (this.complementSelection.length === 0) {
                this.complementError = true
                return false
            }
            if (this.refundFallback.length === 0) {
                this.refundError = true
                return false
            }
            return true
        },
    },
    created() {
        this.autoFillFromWebsiteSetting()
        this.$nextTick(() => {
            this.isInitializing = false
        })
    },
}
</script>

<style scoped>
.ppv2-m-0-forced {
    margin: 0 !important;
}

.number-input::-webkit-outer-spin-button,
.number-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.number-input {
    -moz-appearance: textfield;
    appearance: textfield;
}
</style>
